<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="6" md="3">
                        <v-form v-model="formValid">
                            <v-text-field
                                id="styled-input"
                                v-model="inputedText"
                                class="styled-input"
                                color="teal darken-4"
                                clearable
                                :rules="[validationRules.required, validationRules.number]"
                                @keydown.enter.prevent="selectAccount"
                            >
                                <template v-slot:label>{{$t('Введите № лицевого счёта')}}</template>
                            </v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-btn
                        rounded
                        color="teal darken-4"
                        dark
                        :disabled="!formValid"
                        @click="selectAccount"
                    >{{$t('Поиск')}}</v-btn>
                </v-row>
                <v-row align="center" justify="center">
                    <div class="text-center">
                        <h3>{{ $t(message) }}</h3>
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <div v-if="accountSearchProccessing" class="text-center">
                <v-progress-circular :size="100" indeterminate color="teal"></v-progress-circular>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    components: {},
    data() {
        return {
            formValid: true,
            inputedText: '',
            message: '',
            validationRules: {
                required: value => (!value ? this.$t('Не указан номер') : true),
                number: value => {
                    let checkResult = value > 0 && value < 9999999999;
                    return !checkResult ? this.$t('Не верно указан номер') : true;
                }
            }
        };
    },
    computed: {
        ...mapState('print', ['accountData', 'accountSearchProccessing'])
    },
    watch: {
        inputedText() {
            this.message = '';
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        ...mapActions('print', ['init', 'searchAccount']),
        async selectAccount() {
            if (!this.formValid) return;
            this.message = '';
            let recaptchaToken = await this.recaptcha('/getAccountInfo');
            let result = await this.searchAccount({ accountId: this.inputedText, recaptchaToken: recaptchaToken });
            if (result === 'OK') {
                this.$router.push('/print');
            } else {
                this.message = result;
            }
        },
        async recaptcha(action) {
            let token = await this.$recaptcha(action);
            return token;
        }
    }
};
</script>